import useResource from 'app/hooks/useResource';

import {
  getSalesReport,
  setSalesReportParams
} from 'app/actions/reports';

import {
  salesReport as resource
} from 'app/resources';

const useSalesReport = () => {
  return useResource({
    resource,
    getResource: getSalesReport,
    setResourceParams: setSalesReportParams
  });
}

export default useSalesReport;
